import React from 'react'
import { useAppSelector } from '../../hooks/redux'
import { useTheme, useMediaQuery } from '@mui/material'

import AgentPage from '../../components/templates/AgentPage'
import SidePanel from '../../components/molecules/SidePanel'
import PageContent from '../../components/molecules/PageContent'
import DocumentPanel from './DocumentPanel'
import Content from './Content'
import ErrorToast from '../../components/molecules/ErrorToast'
import SuccessToast from '../../components/molecules/SuccessToast'
import EnvironmentName from '../../components/molecules/EnvironmentName'
import ActionButton from '../../components/organisms/ActionButton'

import { selectArticles } from '@SonarCX/slices/article'
import { useBreakpoint } from '@SonarCX/providers/BreakpointProvider'
import useStyles from './styles'

export const HIDE_TABLE_BP = 1300

const Documents = () => {
  const theme = useTheme()
  const isTableSquished = useMediaQuery(theme.breakpoints.down(HIDE_TABLE_BP))

  const { root, selected, creating, articles, error, successMessage } =
    useAppSelector(selectArticles)
  const { isSmall } = useBreakpoint()

  const [viewingPanel, setViewingPanel] = React.useState(true)

  const onArticle = React.useMemo(() => {
    if (!root) {
      return false
    }

    if (creating) {
      return true
    }

    if (!selected || !articles[selected]) {
      return false
    }

    return articles[selected].type === 'article'
  }, [root, selected, articles, creating])

  const classes = useStyles()

  const toggleView = React.useCallback(() => {
    setViewingPanel(old => !old)
  }, [])

  // Hide the side panel on smaller screens
  React.useEffect(() => {
    if (isTableSquished) {
      setViewingPanel(false)
    }
  }, [isTableSquished])

  return (
    <>
      <AgentPage
        disablePadding
        statsComponent={
          <EnvironmentName
            padLeft={isTableSquished ? 0 : viewingPanel ? 0 : 384}
          />
        }
      >
        <div className={classes.root}>
          {(!isTableSquished || viewingPanel) && (
            <SidePanel title='Knowledge Base' toggleView={toggleView}>
              <DocumentPanel />
            </SidePanel>
          )}

          <PageContent hideIcon toggleView={toggleView}>
            {(!isTableSquished || !viewingPanel) && (
              <div className={onArticle ? classes.article : classes.content}>
                <Content />
              </div>
            )}
          </PageContent>
        </div>

        <ErrorToast error={error ? { err: error } : null} />

        <SuccessToast message={successMessage} />
      </AgentPage>

      {!isSmall && <ActionButton screen='article' />}
    </>
  )
}

export default Documents
